import {
  PreviewSidebarItemType,
  ButtonTabInputType,
} from "containers/admin/clients/client/theme-page/preview/preview-sidebar/preview-sidebar.types";
import ButtonSectionContent from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/button-section-content";

import Icons from "assets";

export const BORDER_RADIUS = "borderRadius";
export const BG_COLOR = "backgroundColor";
export const BORDER_STYLE = "borderStyle";
export const CUSTOM_VALUE = "custom";
export const WIDTH_VALUE = "width";
export const NAME_VALUE = "name";
export const NONE_VALUE = "none";
export const COLOR_VALUE = "color";
export const BUTTON_PADDING = "button.padding";
export const BUTTON_ALIGNMENT = "button.alignment";
export const LEFT_VALUE = "left";
export const TOP_VALUE = "top";
export const RIGHT_VALUE = "right";
export const BOTTOM_VALUE = "bottom";

export const BUTTON_INPUTS: ButtonTabInputType[] = [
  { isRequired: false, name: "backgroundColor", label: "Background color" },
  { isRequired: false, name: "borderRadius", label: "Border radius" },
  { isRequired: false, name: "borderStyle", label: "Border style" },
];

export const BUTTON_TAB_SIDEBAR: PreviewSidebarItemType[] = [
  { titleText: "PARAMETERS", children: <ButtonSectionContent content={BUTTON_INPUTS} /> },
];

export const BUTTON_WIDTH_OPTIONS = [
  {
    label: "Hug content",
    value: "auto",
    icon: <Icons.HugContent />,
  },
  {
    label: "Fill container",
    value: "fill",
    icon: <Icons.WidthFill />,
  },
  {
    label: "Fixed width",
    value: "fixed",
    icon: <Icons.WidthFixed />,
  },
];
